var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 87,
    fill: "#343950"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 85.5,
    stroke: "#E21F1F",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.029 100.627L131.244 74.3029C132.252 73.2905 132.252 71.7718 131.244 70.7593C130.236 69.7469 128.723 69.7469 127.715 70.7593L101.5 97.083L75.2851 70.7593C74.2769 70.2531 72.7645 70.2531 71.7562 70.7593C71.2521 71.7718 71.2521 73.2905 71.7562 74.3029L97.9711 100.627L71.7562 126.95C70.7479 127.963 70.7479 129.481 71.7562 130.494C72.2603 131 72.7645 131 73.7727 131C74.781 131 74.781 131 75.2851 130.494L101.5 104.17L127.715 130.494C128.219 131 128.723 131 129.227 131C129.731 131 130.236 131 130.74 130.494C131.748 129.481 131.748 127.963 130.74 126.95L105.029 100.627Z",
    fill: "white",
    stroke: "#343950"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4",
    x: 0,
    y: 0,
    width: 202,
    height: 202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 14,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_4"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.192157 0 0 0 0 0.282353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIconDark);
export default __webpack_public_path__ + "static/media/cancel-icon-dark.f5d3e7b847f4c1ea45d9f01a854f54a2.svg";
export { ForwardRef as ReactComponent };